import { setBannerIsOpen } from 'store/AppState/actions'
import {
  GET_FEATURE_FLAGS_REQUESTED,
  GET_FEATURE_FLAGS_SUCCEEDED,
  GET_FEATURE_FLAGS_FAILED,
} from 'store/FeatureFlags/constants'
import api from 'utils/api'

const getFeatureFlagsRequired = () => ({
  type: GET_FEATURE_FLAGS_REQUESTED,
})
const getFeatureFlagsSucceeded = (payload) => ({
  type: GET_FEATURE_FLAGS_SUCCEEDED,
  payload: payload,
})
const getFeatureFlagsFailed = (error) => ({
  type: GET_FEATURE_FLAGS_FAILED,
  payload: error,
})

export const fetchFeatureFlags =
  (venueUuid, orgName) => (dispatch) => {
    dispatch(getFeatureFlagsRequired())

    return api
      .fetchFeatureFlags(venueUuid, orgName)
      .then((res) => {
        // when sortCategoriesBySortOrder = false, then the banner is displayed. For a more intuitive way,
        // in store we have: true = banner is displayed, false = banner is not displayed
        const sortCategoriesBySortOrder =
          res?.data?.featureFlags?.sortCategoriesBySortOrder === false
            ? true
            : false

        dispatch(getFeatureFlagsSucceeded(res?.data?.featureFlags))
        dispatch(
          setBannerIsOpen({
            categories: sortCategoriesBySortOrder,
            'modifier-groups': sortCategoriesBySortOrder,
          })
        )
      })
      .catch((err) => dispatch(getFeatureFlagsFailed(err)))
  }
